export const config = {
    baseUrl: process.env.REACT_APP_BASE_URL, // Updated to use environment variable
    accessToken: process.env.REACT_APP_ACCESS_TOKEN // Updated to use environment variable
};  